import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RejectWithMessage } from 'features/types';
import { getErrorMessage } from 'utils/error';
import { ProgramDetailsData, ProgramDetailsState } from './types';
import { programsAPI } from 'api';

export const getProgramDataForAboutPage = createAsyncThunk<ProgramDetailsData, string, RejectWithMessage>(
  'program-details/get',
  async (id, { rejectWithValue }) => {
    try {
      return await programsAPI.getProgramDataForAboutPage(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const initialState: ProgramDetailsState = {
  status: 'idle',
  error: null,
  data: {
    details: null,
  }
};

const programDetailsSlice = createSlice({
  name: 'program-details',
  initialState,
  reducers: {
    setDetails: (state, action: PayloadAction<ProgramDetailsData>) => {
      if (state.data?.details) {
        state.data.details = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProgramDataForAboutPage.pending, (state) => {
      state.status = 'pending';
    });
    builder.addCase(getProgramDataForAboutPage.fulfilled, (state, action: PayloadAction<ProgramDetailsData>) => {
      state.status = 'fulfilled';
      state.data.details = action.payload;
      state.error = null;
    });
    builder.addCase(getProgramDataForAboutPage.rejected, (state) => {
      state.status = 'rejected';
    });
  }
});

export const { setDetails } = programDetailsSlice.actions;
export const programDetailsReducer = programDetailsSlice.reducer;
